/** Edge-to-edge partner booking rows on small screens; keep the status stripe. */
export const partnerBookingMobileChrome =
  "rounded-none border-y-0 border-r-0 shadow-none sm:rounded-lg sm:border sm:border-s-[3px] sm:shadow-xs";

/** Left accent width for partner booking status on cards. */
export const partnerBookingStatusBorderWidth = "border-l-[3px]";

/** Pending handshake tint — opaque on mobile (gray list gutter), subtle on desktop. */
export const partnerHighlightCardClass =
  "bg-accent-50 sm:bg-accent-50/40 dark:sm:bg-accent-50/30";
